import Cookies from 'js-cookie';
import {
    IS_DEV,
    LANGUAGE_KEY,
    PROMO_CODE_KEY,
    SESSION_COOKIE_NAME,
    SESSION_DOMAIN,
    SESSION_LIFETIME,
    SESSION_REQUEST_HEADER_NAME,
} from '../constants/main';

export const setSessionIdCookie: (cookieValue: string) => void = (cookieValue) => {
    const cookieLifetime: number = (parseInt(SESSION_LIFETIME, 10) / 24 / 3600) * 30;

    Cookies.set(SESSION_COOKIE_NAME, cookieValue, {
        domain: SESSION_DOMAIN,
        expires: cookieLifetime,
        strict: !IS_DEV,
    });
};

export const getSessionIdCookie = () => Cookies.get(SESSION_COOKIE_NAME);

export const getLastUpdateSetting = () => Cookies.get('LAST_UPDATE_SETTINGS');
export const setLastUpdateSetting: () => void = () => {
    const cookieLifetime: number = (parseInt(SESSION_LIFETIME, 10) / 24 / 3600) * 30;

    Cookies.remove('LAST_UPDATE_SETTINGS', {
        domain: SESSION_DOMAIN,
    });
    Cookies.set('LAST_UPDATE_SETTINGS', String(Date.now()), {
        expires: cookieLifetime,
        domain: SESSION_DOMAIN,
        sameSite: 'strict',
        strict: !IS_DEV,
    });
};

export const setPromoCodeCookie: (promoCode: string) => void = (promoCode) => {
    const cookieLifetime: number = (parseInt(SESSION_LIFETIME, 10) / 24 / 3600) * 30;

    Cookies.set(PROMO_CODE_KEY, promoCode, {
        domain: SESSION_DOMAIN,
        expires: cookieLifetime,
        sameSite: 'strict',
        strict: !IS_DEV,
    });
};

export const getPromoCodeCookie = () => Cookies.get(PROMO_CODE_KEY);

export const setLanguageCookie: (lang: string) => void = (lang) => {
    const cookieLifetime: number = (parseInt(SESSION_LIFETIME, 10) / 24 / 3600) * 30;

    Cookies.set(LANGUAGE_KEY, lang, {
        domain: SESSION_DOMAIN,
        expires: cookieLifetime,
        sameSite: 'strict',
        strict: !IS_DEV,
    });
};

export const getLanguageCookie = () => Cookies.get(LANGUAGE_KEY);

export const removePromoCodeCookie = () =>
    Cookies.remove(PROMO_CODE_KEY, {
        domain: SESSION_DOMAIN,
    });

export const getSessionHeaders = () => {
    const sessionCookie: string = getSessionIdCookie();
    const sessionIdToken: { [key: string]: string } = {};

    if (sessionCookie) {
        sessionIdToken[SESSION_REQUEST_HEADER_NAME] = sessionCookie;
    }

    return sessionIdToken;
};
